import { Tooltip } from '@mui/material';
import React from 'react';
import { Image } from 'components/Image/Image';
import { IPhoto } from 'pages/SchedulerList/components/Inspection/Inspection.types';
import DeleteIcon from 'assets/svg/close-icon.svg';
import * as S from '../PhotoGallery.styles';

interface IGalleryImageProps {
  photo: IPhoto;
  index: number;
  onImageClick: (index: number, e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  onDeleteClick: (event: React.MouseEvent<HTMLElement>, photo: IPhoto) => void;
  canDelete: boolean;
}

export const GalleryImage: React.FC<IGalleryImageProps> = ({
  photo,
  index,
  onImageClick,
  onDeleteClick,
  canDelete,
}) => {
  return (
    <S.ImageWrapper>
      <S.ImageContainer>
        {canDelete && (
          <S.DeleteIconButton data-testid="delete-icon-btn" type="button" onClick={(e) => onDeleteClick(e, photo)}>
            <img src={DeleteIcon} alt="Botão de excluir foto" />
          </S.DeleteIconButton>
        )}
        <div onClick={(e) => onImageClick(index, e)}>
          <Image data-testid="image-claim-upload" width={130} height={130} alt={photo.name} src={photo.url} />
        </div>
      </S.ImageContainer>
      <Tooltip title={photo.name} placement="bottom">
        <S.FileTitle>{photo.name}</S.FileTitle>
      </Tooltip>
    </S.ImageWrapper>
  );
};
